import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import PropTypes from 'prop-types';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            gcTime: 1000 * 60 * 60 * 24, // 24 hours
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            staleTime: 1000 * 60 * 2, // 2 min
        },
    },
});

const HiverQueryClientProvider = ({children}) => {
    return (
       <QueryClientProvider client={queryClient}>
          {children}
       </QueryClientProvider> 
    ) 
}

HiverQueryClientProvider.propTypes = {
    children: PropTypes.any
};

export default HiverQueryClientProvider
